import { connect } from 'react-redux';
import { logoutAsyncThunk } from '../actions/AuthActions'
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'typesafe-actions';
import RBAC from '../components/RBAC';
import { RouteComponentProps } from 'react-router';
import { UserRole } from '../reducers/AuthRdc';
import { ReactNode } from 'react';

type OwnProps = {
    children?: ReactNode,
    for?: UserRole,
    getDefaultView?: boolean
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
    return ({
        currentUserRole: state.authRdc.userRole,
        for: ownProps.for,
        getDefaultView: ownProps.getDefaultView
  })};
  

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): any => {
    return {
        logout: async () => {
            await dispatch(logoutAsyncThunk())
        }
    }
}


export type RBACProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & RouteComponentProps & OwnProps

const RBACCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(RBAC);

export default RBACCnn